import { isIOS, isMobileOnly, osVersion } from 'react-device-detect'

export default function useSettings() {
  return {
    dpr: 1,
    needsWebgl1: () => isMobileOnly && isIOS && parseInt(osVersion) < 15
  }
}
